const frontendTools = [
    {
        name : "HTML",
        image : "tools/htmlIcon.png"
    },
    {
        name : "CSS",
        image : "tools/cssIcon.png"
    },
    {
        name : "JS",
        image : "tools/jsIcon.png"
    },
    {
        name : "React",
        image : "tools/reactIcon.png"
    },
    {
        name : "Redux",
        image : "tools/reduxIcon.png"
    },
    {
        name : "TS",
        image : "tools/tsIcon.png"
    },
    {
        name : "Bootstrap",
        image : "tools/bootstrapIcon.png"
    },
    {
        name : "Next",
        image : "tools/nextIcon.png"
    },
    {
        name : "MUI",
        image : "tools/muiIcon.png"
    },
    {
        name : "Tailwind",
        image : "tools/tailwindIcon.png"
    },
    {
        name : "Angular",
        image : "tools/angularIcon.png"
    },
]

const backendTools = [
    {
        name : "Node",
        image : "tools/nodeIcon.png"
    },
    {
        name : "MongoDB",
        image : "tools/mongodbIcon.png"
    },
    {
        name : "Python",
        image : "tools/pythonIcon.png"
    },
    {
        name : "C",
        image : "tools/clangIcon.png"
    },
    {
        name : "C++",
        image : "tools/cplusplusIcon.png"
    },
    {
        name : "Nest",
        image : "tools/nestIcon.png"
    },
    {
        name : "FastAPI",
        image : "tools/fastapiIcon.png"
    },
    {
        name : "Swagger",
        image : "tools/swaggerIcon.png"
    },
    {
        name : "MySQL",
        image : "tools/mysqlIcon.png"
    },
    {
        name : "Postman",
        image : "tools/postmanIcon.png"
    },
]

const otherTools = [
    {
        name : "Git",
        image : "tools/gitIcon.png"
    },
    {
        name : "Jest",
        image : "tools/jestIcon.png"
    },
    {
        name : "Github",
        image : "tools/githubIcon.png"
    },
    {
        name : "Gitlab",
        image : "tools/gitlabIcon.png"
    },
    {
        name : "VScode",
        image : "tools/vscodeIcon.png"
    },
    {
        name : "Intellij",
        image : "tools/intellijIcon.png"
    },
    {
        name : "Netlify",
        image : "tools/netlifyIcon.png"
    },
    {
        name : "Heroku",
        image : "tools/herokuIcon.png"
    },
    {
        name : "Confluence",
        image : "tools/confluenceIcon.png"
    },
    {
        name : "Whimsical",
        image : "tools/whimsicalIcon.png"
    },
    {
        name : "Notion",
        image : "tools/notionIcon.png"
    },
    {
        name : "Jira",
        image : "tools/jiraIcon.png"
    },
    {
        name : "Hugging Face",
        image : "tools/huggingIcon.png"
    },
    {
        name : "Kafka",
        image : "tools/kafkaIcon.png"
    },
    {
        name : "Datadog",
        image : "tools/datadogIcon.png"
    },
    {
        name : "Redis",
        image : "tools/redisIcon.png"
    },
]

export const toolsTech = [
    {
        title : "Front-end",
        tools : frontendTools
    },
    {
        title : "Back-end",
        tools : backendTools
    },
    {
        title : "Other",
        tools : otherTools
    },
]